import { createContext, useContext } from 'react'

import { type User } from './user'

interface CurrentUser {
  user: User
  isLoading: boolean
}

const CurrentUserContext = createContext<CurrentUser | undefined>(undefined)

const CurrentUserContextProvider = CurrentUserContext.Provider

const useCurrentUserContext = (): CurrentUser => {
  const userContext = useContext(CurrentUserContext)

  if (!userContext) {
    throw new Error('Attempted to access CurrentUser context outside of CurrentUser provider.')
  }

  return userContext
}

const useCurrentUser = (): CurrentUser => {
  const { user, isLoading } = useCurrentUserContext()
  return { user, isLoading }
}

export { CurrentUserContextProvider, useCurrentUser }
